'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:UpdatePaymentInfoCtrl
 * @description
 * # UpdatePaymentInfoCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('UpdatePaymentInfoCtrl', function ($location, $scope, api, stripe3ds, COUNTRIES, /**PaymentUpdatePayload*/paymentInfoPayload) {
		$scope.countries = COUNTRIES;

		/**
		 * @type {PaymentUpdatePayload}
		 */
		$scope.payment = paymentInfoPayload;
		if ($scope.payment?.card?.cardpointePaymentToken) {
			$scope.payment.card.cardpointePaymentToken = '';
		}

		$scope.submitPaymentInfo = async () => {
			$scope.myForm.$$setSubmitted();
			if ($scope.myForm.$invalid) {
				return toastr.error('Please correct invalid form data first');
			}
			let cc = $scope.payment.card;
			if (!cc.cardpointePaymentToken) {
				return toastr.error('Please finish entering credit card info', 'Missing/Invalid Credit Card');
			}
			const errors = [], warnings = [];
			try {
				let payload = $scope.payment;
				let result = await api.updatePaymentInfo(payload);
				errors.push(...(result.errors || []));
				warnings.push(...(result.warnings || []));
				// A renewal charged from this page may need the bank's verification step. Run it, then go back for the
				// licenses after the one that was challenged; the server finished everything before it already.
				while (result.stripe3DS) {
					await stripe3ds.challenge(result.stripe3DS); // rejects with 'cancel' if the customer backs out
					const remaining = new Set(result.stripe3DS.remainingCartItemIds);
					if (!remaining.size) {
						break;
					}
					payload = angular.extend({}, payload, {candidates: payload.candidates.filter(c => remaining.has(c.cartItemId))});
					result = await api.updatePaymentInfo(payload);
					errors.push(...(result.errors || []));
					warnings.push(...(result.warnings || []));
				}
				if (errors.length) {
					toastr.warning('Your payment info has been updated, with ' + errors.length + ' issue(s): ' + errors.join('. \n'));
				} else if (warnings.length) {
					// card saved, but the license was too far lapsed to renew automatically
					toastr.warning('Your payment info has been updated. ' + warnings.join('. \n'));
				} else {
					toastr.success('Your payment info has been updated', 'Success');
				}
				$location.path('/'); // FIX! take to myAccount page, once one exists -ssb
			} catch (e) {
				if (e === 'cancel') {
					return toastr.warning('Verification cancelled. Your card has been saved, but the renewal has not been charged yet.');
				}
				console.error('Error during submitPaymentInfo', e);
			}
		};

		$scope.toggle = function (item) {
			item.selected = !item.selected;
			window.event.stopPropagation();
			$scope.noneChecked = $scope.payment.candidates.filter(function (o) {
				return o.selected;
			}).length === 0;
		};

	});
